module.exports = __webpack_public_path__ + "img/image166.def28889.jpg";